"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBadgerOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var BBadgerOracleFactory = /** @class */ (function (_super) {
    __extends(BBadgerOracleFactory, _super);
    function BBadgerOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    BBadgerOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BBadgerOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BBadgerOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BBadgerOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BBadgerOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return BBadgerOracleFactory;
}(contracts_1.ContractFactory));
exports.BBadgerOracleFactory = BBadgerOracleFactory;
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "bBadger",
        outputs: [
            {
                internalType: "contract IBadgerSett",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "badger",
        outputs: [
            {
                internalType: "contract BaseERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "badgerEthChainlinkOracle",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "badgerEthChainlinkScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "badgerScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainLinkEthAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainlinkEthScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
